import styled from 'styled-components';

export const Container = styled.div`
  > h4 {
    font-weight: bold;
  }
`;
export const ContainerBodyModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  margin: 1rem 0;
  min-height: 100px;
`;

export const SummaryCart = styled.div`
  display:grid;
  grid-template-columns: 1fr 1fr;

  margin: 2rem 0 0;
  font-weight: bold;
  font-size: 0.9rem;

  p {
    margin: 0;
  }

  & > p:nth-child(even) {
    display: flex;
    justify-content: flex-end;
    text-align: right;
  }
`;

export const AreaProducts = styled.div`
  max-height: 500px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const FooterButtons = styled.div`
  display: flex;
  flex-direction: column;

  & > button {
    margin: 0 0 1rem 0;
    width: 100%;
    max-width: 100%;
  }
`;

export const BoxProductSupplier = styled.div`
  border: 1px solid #ccc;
  border-radius: 10px;
  font-weight: bold;
  word-break: break-word;
`;
export const TextoInfoProduct = styled.div`
  padding: 0.3rem 0.6rem 0 0.6rem;
`;

export const AreaFreeShipping = styled.div`
  display: flex;
  flex-direction: row;
  gap: .4rem;
`;

export const TextFreeShipping = styled.p`
  color: ${({ theme }) => theme.pantone2727C};
`;

export const PriceFreeShipping = styled.span`
  color: ${({ theme }) => theme.pantone2727C};
  font-size: .9rem;
`;